module.exports = __webpack_public_path__ + "static/media/image_with_text.a68722eb.jpg";